import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import OrderList from '../views/OrderList.vue'
import AddressList from '../views/AddressList.vue'
import AddressEdit from '../views/AddressEdit.vue'
import LogisticsDetail from '../views/LogisticsDetail.vue'
import { isLoggedIn, getStaffToken } from '../utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录', requiresAuth: false }
  },
  {
    path: '/orders',
    name: 'OrderList',
    component: OrderList,
    meta: { title: '我的订单', requiresAuth: true }
  },
  {
    path: '/address',
    name: 'AddressList',
    component: AddressList,
    meta: { title: '收货地址', requiresAuth: true }
  },
  {
    path: '/address/edit/:id?',
    name: 'AddressEdit',
    component: AddressEdit,
    meta: { title: '编辑地址', requiresAuth: true }
  },
  {
    path: '/logistics/:id',
    name: 'LogisticsDetail',
    component: LogisticsDetail,
    meta: { title: '物流信息', requiresAuth: true }
  },
  {
    path: '/yewuduan',
    component: () => import('@/views/yewuduan/Layout.vue'),
    meta: { requiresStaffAuth: true },
    children: [
      {
        path: '',
        redirect: '/yewuduan/home'
      },
      {
        path: 'login',
        component: () => import('@/views/yewuduan/Login.vue'),
        meta: { guest: true }
      },
      {
        path: 'register',
        component: () => import('@/views/yewuduan/Register.vue'),
        meta: { guest: true }
      },
      {
        path: 'storeRegister',
        component: () => import('@/views/yewuduan/StoreRegister.vue'),
        meta: { guest: true, title: '营业厅入驻注册' }
      },
      {
        path: 'home',
        component: () => import('@/views/yewuduan/Home.vue'),
        meta: { title: '核销首页' }
      },
      {
        path: 'verify/:orderId',
        component: () => import('@/views/yewuduan/VerifyOrder.vue'),
        meta: { title: '确认核销' }
      },
      {
        path: 'verify-phone',
        component: () => import('@/views/yewuduan/VerifyByPhone.vue'),
        meta: { title: '手机号核销' }
      },
      {
        path: 'replenish',
        component: () => import('@/views/yewuduan/ReplenishList.vue'),
        meta: { title: '补货单', role: 'manager' }
      },
      {
        path: 'replenish-edit/:id?',
        component: () => import('@/views/yewuduan/ReplenishEdit.vue'),
        meta: { title: '编辑补货单', role: 'manager' }
      },
      {
        path: 'replenish-logistics/:id',
        component: () => import('@/views/yewuduan/ReplenishLogistics.vue'),
        meta: { title: '补货物流', role: 'manager' }
      },
      {
        path: 'history',
        component: () => import('@/views/yewuduan/VerifyHistory.vue'),
        meta: { title: '核销历史' }
      },
      {
        path: 'staff-manage',
        component: () => import('@/views/yewuduan/StaffManage.vue'),
        meta: { title: '店员管理', role: 'manager' }
      },
      {
        path: 'invite',
        component: () => import('@/views/yewuduan/InvitePage.vue'),
        meta: { title: '邀请管理', role: 'manager' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isYewuduanRoute = to.path.startsWith('/yewuduan')

  if (isYewuduanRoute) {
    const staffToken = getStaffToken()

    if (to.meta.guest) {
      next()
    } else if (!staffToken) {
      next('/yewuduan/login?redirect=' + to.fullPath)
    } else {
      if (to.meta.title) {
        document.title = to.meta.title
      }
      next()
    }
  } else {
    if (to.meta.requiresAuth !== false && !isLoggedIn()) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      })
    } else {
      if (to.meta.title) {
        document.title = to.meta.title
      }
      next()
    }
  }
})

export default router